import {
  type EpocusProgram,
  type EpocusProgramQueryConstructor,
  RXDB_EPOCUS_PROGRAM_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-program";
import { useMemo } from "react";
import { useRxData } from "rxdb-hooks";

const activeProgramsQuery: EpocusProgramQueryConstructor = (collection) =>
  collection?.find({
    selector: { status: { $eq: "active" } },
    sort: [{ name: "asc" }],
  });

/**
 * Picking one of several programs here would stamp rows with a program the
 * backfill cannot move and every later push rejects; a null is recoverable.
 */
export const selectActiveProgramId = (
  programs: readonly EpocusProgram[],
): string | null => (programs.length === 1 ? (programs[0]?.id ?? null) : null);

export const selectActiveProgram = (
  programs: readonly EpocusProgram[],
): EpocusProgram | null =>
  programs.length === 1 ? (programs[0] ?? null) : null;

export const useMyPrograms = () => {
  const { result, isFetching } = useRxData<EpocusProgram>(
    RXDB_EPOCUS_PROGRAM_COLLECTION_NAME,
    activeProgramsQuery,
  );

  return { programs: result, loading: isFetching };
};

export const useActiveProgramId = (): string | null => {
  const { programs } = useMyPrograms();

  return useMemo(() => selectActiveProgramId(programs), [programs]);
};
